<template>
  <div
    v-if="isActive"
    class="modern-dialog dialog modal is-active"
    :class="dialogClass"
    v-trap-focus="trapFocus"
    :role="ariaRole"
    :aria-modal="ariaModal">
    <div class="modal-background" @click="cancel('outside')"/>
    <div class="modal-card animation-content">
      <header class="modal-card-head" v-if="title">
        <p class="modal-card-title">{{ title }}</p>
        <button class="modal-close is-large" @click="cancel('button')"></button>
      </header>
      <section
        class="modal-card-body"
        :class="{ 'is-titleless': !title, 'is-flex': hasIcon }">
        <div class="media">
          <div
            class="media-left"
            v-if="hasIcon && (icon || iconByType)">
            <b-icon
              :icon="icon ? icon : iconByType"
              :pack="iconPack"
              :type="type"
              :both="!icon"
              size="is-large"/>
          </div>
          <div class="media-content">
            <p v-html="message"/>

            <div v-if="hasInput" class="field">
              <div class="control">
                <input
                  v-model="prompt"
                  class="input"
                  ref="input"
                  :class="{ 'is-danger': validationMessage }"
                  v-bind="inputAttrs"
                  @keyup.enter="confirm">
              </div>
              <p class="help is-danger">{{ validationMessage }}</p>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button
          v-if="showCancel"
          class="button"
          ref="cancelButton"
          @click="cancel('button')">{{ cancelText }}</button>
        <button
          class="button"
          :class="type"
          ref="confirmButton"
          @click="confirm">{{ confirmText }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import Dialog from 'buefy/src/components/dialog/Dialog.vue';

export default {
  name: 'ModernDialog',
  extends: Dialog,
};
</script>

<style lang="stylus">

</style>
